<img id="auth-logo" src="assets/img/logo/logo-bisual-black.png" alt="bisual" />
<div id="auth-container">
  <router-outlet></router-outlet>
</div>
